import { login } from "@/services";
import { gaodingEditHost } from "@/utils/host";
import { checkLogin } from "@/utils/open";
import { AppLink } from "@gdesign/applink";

export class OrgService {
  private static instance: OrgService;
  private applink: AppLink;
  private currentUser: any = null;

  private constructor() {
    this.applink = new AppLink();
    this.applink.popup.setOrigin(`https://${gaodingEditHost}`);
    // this.applink.popup.setOrigin(`https://www-local-fat.gaoding.com`); // 本地开发
  }

  static getInstance() {
    if (!OrgService.instance) {
      OrgService.instance = new OrgService();
    }
    return OrgService.instance;
  }

  private async ensureUser() {
    if (!this.currentUser) {
      try {
        this.currentUser = await checkLogin();
      } catch (error) {
        console.error("获取用户信息失败:", error);
        return null;
      }
    }
    return this.currentUser;
  }

  async createOrg() {
    const user = await this.ensureUser();
    if (!user) {
      return;
    }

    const modal = this.applink.open("/applink/popup/create-org", {
      mode: "iframe",
      props: {
        // project_env: "p785pr10249", // 开发联调使用
        design_token: "huaban",
        seatType: "gdmaterial",
      },
    });
    modal.on("ok", () => {
      console.info("🏠➕ createOrg modal ok");
      location.reload();
    });
    modal.on("cancel", () => {
      console.info("🏠➕ createOrg modal cancel");
    });
  }

  async upgradeOrg() {
    const user = await this.ensureUser();
    if (!user) {
      return;
    }

    try {
      const modal = this.applink.open("/applink/popup/upgrade-org", {
        mode: "iframe",
        props: {
          // project_env: "p785pr10249", // 开发联调使用
          design_token: "huaban",
          seatType: "gdmaterial",
        },
      });
      modal.on("ok", () => {
        console.info("🏠➕ upgradeOrg modal ok");
        location.reload();
      });
      modal.on("cancel", () => {
        console.info("🏠➕ upgradeOrg modal cancel");
      });
    } catch (error) {
      console.error("升级组织失败:", error);
    }
  }

  async inviteMember() {
    const user = await this.ensureUser();
    if (!user) {
      login();
      return;
    }

    try {
      this.applink.open("/applink/popup/invite-member", {
        mode: "iframe",
        props: {
          // project_env: "p785pr10249", // 开发联调使用
          design_token: "huaban",
        },
      });
    } catch (error) {
      console.error("邀请成员失败:", error);
    }
  }
}
